import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Gift, Sparkles, ArrowRight } from "lucide-react";
import { useEntitlements } from "../context/EntitlementsContext";

const TITLES = {
  command_center: "Command Center",
  ai_journal: "AI Trade Journal",
  analytics: "Advanced Analytics",
  ai_coach: "WS Coach",
  ai_chart: "Live Market Analyser",
  news_pro: "WS News Pro",
  community: "WS VIP Community",
  ws_vip: "WS VIP Community",
  leaderboard: "WS Leaderboard",
};

const UNLOCK_HINT = {
  news_pro: "Refer 10 friends to unlock 10 days free.",
  ai_journal: "Refer 50 friends to unlock 15 days free.",
  analytics: "Refer 50 friends to unlock 15 days free.",
  community: "Refer 15 friends to unlock VIP access.",
  ws_vip: "Refer 15 friends to unlock VIP access.",
};

const DemoLock = ({ featureKey }) => {
  const navigate = useNavigate();
  const { ent } = useEntitlements();
  const title = TITLES[featureKey] || "This feature";
  const refs = ent?.referrals ?? 0;

  return (
    <div className="ws-demolock" data-testid={`demo-lock-${featureKey}`}>
      <div className="ws-demolock-card ws-fade-up">
        <div className="ws-demolock-badge"><Lock className="w-3.5 h-3.5" /> Demo mode</div>
        <div className="ws-demolock-icon"><Lock className="w-8 h-8" /></div>
        <h2 className="ws-heading text-2xl sm:text-3xl font-bold mt-4">{title} is locked</h2>
        <p className="text-[color:var(--ws-muted)] text-sm mt-3 max-w-md mx-auto">
          Connect a verified <span className="text-white font-semibold">XM</span> or{" "}
          <span className="ws-elefin-glow font-semibold">Elefin</span> account to unlock the entire
          platform — <span className="text-white font-semibold">100% free</span>. No broker yet? Grow
          your access in the Growth Zone by referring friends.
        </p>
        {UNLOCK_HINT[featureKey] && (
          <p className="text-[12px] text-[color:var(--ws-cyan)] mt-3">{UNLOCK_HINT[featureKey]} You're at {refs} referrals.</p>
        )}
        <div className="ws-demolock-actions">
          <button className="ws-btn-primary" data-testid="demolock-connect" onClick={() => navigate("/connect")}>
            <Sparkles className="w-4 h-4" /> Connect a broker (free)
          </button>
          <button className="ws-btn-ghost" data-testid="demolock-growth" onClick={() => navigate("/growth-zone")}>
            <Gift className="w-4 h-4" /> Go to Growth Zone <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DemoLock;
